import * as yup from "yup";
import { FormInputMeta } from "@Modules/core/types/FormMetaType";
import { getValidationSchema } from "@Shared/utils/validationSchema";

export interface ITrialsAuthorizationRejectedFormMeta {
    rulesIdentification: FormInputMeta;
    description: FormInputMeta;
    status: FormInputMeta;
    riskLevel: FormInputMeta;
    minSeriesNumber: FormInputMeta;
    authorizedAmount: FormInputMeta;
    decreasingThreshold: FormInputMeta;

    schema: any;
}

const trialsAuthorizationRejectedFormMeta = {} as ITrialsAuthorizationRejectedFormMeta;

trialsAuthorizationRejectedFormMeta.rulesIdentification = {
    name: "rulesIdentification",
    type: "text",
    label: "Identification Règles",
    placeholder: "Identification Règles",
    validation: yup.string().required("Champ obligatoire !")
};

trialsAuthorizationRejectedFormMeta.description = {
    name: "description",
    type: "textarea",
    label: "Description",
    placeholder: "Description",
    validation: yup.string().required("Champ obligatoire !")
};

trialsAuthorizationRejectedFormMeta.status = {
    name: "status",
    type: "select",
    label: "Statut",
    placeholder: "",
    validation: yup.string().required("Champ obligatoire !")
};

trialsAuthorizationRejectedFormMeta.riskLevel = {
    name: "riskLevel",
    type: "number",
    label: "Niveau Risque",
    placeholder: "",
    validation: yup.number().required("Champ obligatoire !")
};

trialsAuthorizationRejectedFormMeta.minSeriesNumber = {
    name: "minSeriesNumber",
    type: "text",
    label: "Num. Séries Min",
    placeholder: "",
    validation: yup.string().required("Champ obligatoire !")
};

trialsAuthorizationRejectedFormMeta.authorizedAmount = {
    name: "authorizedAmount",
    type: "text",
    label: "Montant Aut.",
    placeholder: "",
    validation: yup.number().required("Champ obligatoire !")
};

trialsAuthorizationRejectedFormMeta.decreasingThreshold = {
    name: "decreasingThreshold",
    type: "text",
    label: "Seuil Décroissant %",
    placeholder: "",
    validation: yup.number().required("Champ obligatoire !")
};


trialsAuthorizationRejectedFormMeta.schema = yup.object().shape(getValidationSchema(trialsAuthorizationRejectedFormMeta));

export default trialsAuthorizationRejectedFormMeta;